import { GetReportsDto } from "../../model/reports/dto/GetReportsDto";
import { GetReportsResponseDto } from "../../model/reports/dto/GetReportsResponseDto";
import { AtiraApi } from "../AxiosClient";

export class ReportAxios {
  static getReport(dto: GetReportsDto) {
    return AtiraApi.post<GetReportsResponseDto>("/reports", dto).then(
      ({ data }) => data,
    );
  }
}
